import { render, staticRenderFns } from "./EducationalBackgroundForm.vue?vue&type=template&id=27aa3c85&scoped=true"
import script from "./EducationalBackgroundForm.vue?vue&type=script&lang=js"
export * from "./EducationalBackgroundForm.vue?vue&type=script&lang=js"
import style0 from "./EducationalBackgroundForm.vue?vue&type=style&index=0&id=27aa3c85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27aa3c85",
  null
  
)

export default component.exports